<template>
    <div class="ml-auto d-flex align-items-center">
        <div>
            <input @change="save()" type="date" class="form-control" v-model="form.expiration_date">
        </div>
        <div class="ml-2" v-if="form.expiration_date != original_exp_date">
            <field-file-model @change="save()" class="mb-0" v-model="form.file"></field-file-model>
        </div>
    </div>
</template>
<script>
export default {
    props: ['type', 'userId', 'document'],

    data() {
        return {
            original_exp_date: moment(this.document.date).format('Y-MM-DD'),
            form: new Form({
                type: this.type,
                expiration_date: moment(this.document.date).format('Y-MM-DD'),
                field: this.document.field,
                name: this.document.name,
                file: null,
            }).dontClear()
                .uploadFiles()
        }
    },

    methods: {
        save() {
            if (!this.form.file) return;
            this.form.post(`/update/expired-documents/${this.userId}`).then(response => {
                console.log(response)
                Alert.withAction(`File Updated`).then(() => {
                    this.refreshPage()
                })
            }).catch(errors => {
                Alert.error(errors.first());
            })
        }
    }
}
</script>

